var _mask, _rect, _path, _rect2, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootprintVod(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_113_2222",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 24,
    width: 124.956,
    height: 80.5792,
    rx: 4.8
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 24,
    width: 124.956,
    height: 80.5792,
    rx: 4.8,
    stroke: "white",
    strokeWidth: 12.8,
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_113_2222)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.3471 64.2891L60.5402 77.4567L60.5402 51.1216L83.3471 64.2891Z",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 124.753,
    y: 84.333,
    width: 10.8066,
    height: 18.3713,
    fill: "#5D38E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.808 83.5576C152.808 104.569 114.271 104.569 114.271 125.599",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.271 83.5576C114.271 104.569 152.808 104.569 152.808 125.599",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.808 125.599H114.271V134.941H152.808V125.599Z",
    fill: "#5D38E5",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.643 83.5572H114.271L114.436 73.0469H152.808L152.643 83.5572Z",
    fill: "#5D38E5",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprintVod);
export default __webpack_public_path__ + "static/media/footprint_vod.e109a615db125824d4222a82545a0dd9.svg";
export { ForwardRef as ReactComponent };